import { normalText } from '../../../styles';

export const sxCardContent = { padding: { xs: '0.5rem' } };

export const sxLogoBox = {
  mt: 2,
  mb: 2,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
};

export const sxLogoTitle = { fontSize: '1.6rem' };

export const sxDivider = { height: '1px' };

export const sxMainBox = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
  py: 3
};

export const sxDetailsGrid = { maxWidth: 500, mx: 'auto' };

export const sxDetailsItem = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
};

export const sxSubtitle = {
  ...normalText,
  textAlign: 'center',
  maxWidth: 300,
  wordBreak: 'break-word'
};

export const sxForm = {
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center', // (opcional) Centraliza verticalmente se tiver altura definida
  alignItems: 'center'
} as const;

export const sxRadioGroup = { width: '13rem', justifyContent: 'space-between', alignItems: 'center', display: 'flex' };

export const sxRadio = { '&:hover': { bgcolor: 'transparent' } };

export const sxErrorText = { ml: 1, fontSize: '1.2rem' };

export const sxButton = { mt: 2 };
